export const SET_USER_TESTS_DATA = "SET_USER_TESTS_DATA";
export const REMOVE_TESTS_EXERCISES_DATA = "REMOVE_TESTS_EXERCISES_DATA";
export const SET_USER_TESTS_RESULT_DATA = "SET_USER_TESTS_RESULT_DATA";
